export const HEIGHT_HEADER = 50;
export const HEIGHT_CREDIT_ALERT = 64;
